module.exports = {"blocks":[{"type":"sections/contact","prefix":"contact"}],"show_business_contact":false,"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1fZu7GOdyoccG-n2zzlElvZqsEr4uZdWSjlmzPobh56I","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/contact/setting.json
// module id = 490
// module chunks = 0 1 2 3 4 5